export default class ConfigHelper {
  // eslint-disable-next-line space-before-function-paren
  constructor() {
    this.tenantConfig = null
  }

  fetchConfig (force = false) {
    if (!force && this.tenantConfig) {
      return Promise.resolve(this.configtenantConfig)
    }
    return fetch('resources/config.json')
      .then(res => res.json())
      .then(config => {
        this.tenantConfig = config
        return this.tenantConfig
      })
  }
}
